import * as React from "react";
import { useNavigate } from "react-router-dom";

//MUI
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ClientInvoicesMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (route) => {
    handleClose();
    navigate(route);
  };

  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <Button
          sx={{ my: 2, color: "white", display: "flex" }}
          onClick={handleOpen}
          endIcon={<ExpandMoreIcon />}
        >
          Ekonomi
        </Button>
      </ClickAwayListener>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        sx={{ mt: 2 }}
      >
        <MenuItem onClick={() => handleClick("/books")}>Bokföring</MenuItem>
        <MenuItem onClick={() => handleClick("/accountcharts")}>
          Kontoplan
        </MenuItem>
        <MenuItem onClick={() => handleClick("/balances")}>Saldon</MenuItem>
        <MenuItem onClick={() => handleClick("/books/sie")}>
          SIE Export
        </MenuItem>
      </Menu>
    </div>
  );
}
